import React from 'react'
import { useLocation } from "react-router-dom";
import VIISPCallbackHandler from "./VIISPCallbackHandler";

export default function VIISPLoginReactCallback() {
    const location = useLocation();
    return <VIISPCallbackHandler query={new URLSearchParams(location.search)} />
}
